import { beat, unit } from './story';
import { SETTLES } from './tempo';

/**
 * "Release": the complete passport is released. The camera goes back to the
 * top, the cursor presses the status pill, and Draft turns Released #1: the
 * lock banner comes in and the values lock. (The app confirms a release in a
 * dialog first; a vignette opens no dialog, so the press releases.) On the
 * phone, the public page's status turns Released, and a reader switches it
 * to German. Page: the passport.
 */
export const RELEASE = unit('release', {
    page: 'passport',
    beats: [
        beat('top', 400),
        beat('point-pill', 150),
        beat('release', 950, { settles: SETTLES.banner }),
        beat('phone-badge', 250),
        beat('phone-lang', 900),
    ],
});
